module.exports = __webpack_public_path__ + "static/media/Modelo2.695cc6b4.png";